import { IButton, IButtonProps } from "../IButton";

import withInfoTooltipHoc from "../../../hocs/with-info-tooltip";

export const ButtonWithInfoTooltip = withInfoTooltipHoc<IButtonProps>(IButton);
